'use client';

/**
 * WebQAShortAnswerCard — Reception fast-tier short summary.
 *
 * Reads `useDocsStore.response.summary.fast.short` (falls back to
 * `short_answer` for V1 responses). ~25-30 word voice/TTS-friendly
 * answer; the cheapest depth in the tiered response shape.
 *
 * Empty state stays quiet — the input card teaches the affordance.
 *
 * @layer presentation
 * @arch_component_type widget
 * @arch_domain canvas
 */

import { useDocsStore } from '@/lib/stores/docs-store';
import { useCardTypography } from '@/lib/design/card-chrome';
import { cn } from '@/lib/utils/cn';
import { FastTierSourceTag } from './web-qa-fast-source';
import { QA_SECTION, QA_BOX } from './web-qa-chrome';


export function WebQAShortAnswerCard() {
  const T = useCardTypography();
  const response = useDocsStore((s) => s.response);

  if (!response) return null;

  const text = response.summary?.fast?.short ?? response.short_answer ?? '';
  if (!text) return null;

  return (
    <section className={QA_SECTION}>
      <div className="w-full">
        <div className={QA_BOX}>
          <FastTierSourceTag />
          <div className={cn(T.metadata, 'mb-2 uppercase tracking-wider text-xs')}>
            Short answer
          </div>
          <p className={cn(T.body, 'text-lg leading-relaxed whitespace-pre-line')}>
            {text}
          </p>
        </div>
      </div>
    </section>
  );
}
